var map = {
	"./address_image.svg": 256,
	"./animated_ashutosh.png": 2855,
	"./animated_logo.svg": 1522,
	"./blogs_image.svg": 3490,
	"./bosch.png": 9875,
	"./bosch.webp": 4621,
	"./channel.jpg": 7431,
	"./channel.png": 7586,
	"./cloud_infrastructure.svg": 2920,
	"./codeInLogo.png": 7942,
	"./contactMail.png": 5420,
	"./coursera_logo.png": 4664,
	"./data_science.svg": 4812,
	"./deeplearning_ai_logo.png": 8669,
	"./delhivery_logo.png": 4655,
	"./developerActivity.svg": 36,
	"./dsc_logo.png": 1710,
	"./education.svg": 9369,
	"./experience.svg": 1017,
	"./feelingProud.svg": 998,
	"./freecopy_logo.png": 9183,
	"./fullstack.svg": 5922,
	"./gcp_logo.png": 4585,
	"./github_logo.png": 2861,
	"./googleAssistant.jpg": 6347,
	"./googleAssistant.svg": 760,
	"./google_logo.png": 8720,
	"./ibm_logo.png": 5117,
	"./iiitk_logo.png": 9922,
	"./intel_logo.jpg": 3852,
	"./iris.png": 9346,
	"./iu_logo.png": 6292,
	"./jsFramework.svg": 860,
	"./kt.png": 1137,
	"./ktu.png": 4881,
	"./legato_logo.png": 4108,
	"./manOnTable.svg": 8776,
	"./microsoft_logo.png": 3562,
	"./mozilla_logo.png": 9704,
	"./muffito_logo.png": 1547,
	"./nextuLogo.jpg": 1462,
	"./nptel_logo.png": 5988,
	"./portfolio.gif": 2598,
	"./programmer.svg": 522,
	"./projects_image.svg": 6274,
	"./pwa.png": 9370,
	"./saayaHealthLogo.png": 6326,
	"./stanford_logo.png": 3777,
	"./talksCardBack.svg": 2592,
	"./talksCardBackAlt.svg": 5092,
	"./tiktok_logo.png": 9033,
	"./ui_ux_design.svg": 9449
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;